import { render, staticRenderFns } from "./searchResultsPage.vue?vue&type=template&id=31ffe9b9&scoped=true"
import script from "./searchResultsPage.vue?vue&type=script&lang=js"
export * from "./searchResultsPage.vue?vue&type=script&lang=js"
import style0 from "./searchResultsPage.vue?vue&type=style&index=0&id=31ffe9b9&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31ffe9b9",
  null
  
)

export default component.exports